<template>
	<div id='moviAdd'>
		<h2>Agregar Movimiento</h2>
		<br>
		<a @click="$router.go(-1)">regresar</a>
		<br><br>   
	    <button type='button' v-on:click='aBuscar' class="button is-primary is-rounded">BUSCAR CONTRATO</button>
	    <label v-model= 'this.movimientos.contrato' > {{movimientos.contrato}}</label>
		<br>
		<br>
		<p>
				<hijo1 v-if='buscar' v-on:eventoC= 'recibeC(...arguments)'>Cargando contratos...</hijo1>
  		</p>

      	<form v-on:submit.prevent= 'guardarMovimiento' id="visible" >			
	
			<table align="center" class="table is-striped is-hoverable">
				<tr>
					<td>Inquilino Nombre</td>
					<td v-model="this.movimientos.inquilinoNombre">{{movimientos.inquilinoNombre}}</td>
				</tr>
				<tr>
					<td>Propiedad Nombre:</td>
					<td v-model="movimientos.propiedadNombre">{{movimientos.propiedadNombre}}</td>
				</tr>
				<tr>
					<td>Giro:</td>
					<td v-model="movimientos.giro"><font color="blue">{{movimientos.giro}}</font></td>
				</tr>
				<tr>
					<td>Familia:</td>
					<td v-model="movimientos.familia"><font color="blue">{{movimientos.familia
					}}</font></td>
				<tr>			
					<td>Tipo</td>
					<td>
						<div class="select is-rounded">
							<select id = "tipo" v-model="movimientos.tipo" v-on:change='visibles()'  required>
								<option disabled value="">Tipo</option>
								<option value="PAGO">PAGO DEL INQUILINO</option>
								<option value="COBRO">COBRO AL INQUILINO</option>
								<option value="DEPOSITO EN GARANTIA">DEPOSITO EN GARANTIA</option>
								<option value="AJUSTE POSITIVO">AJUSTE POSITIVO</option>
								<option value="AJUSTE NEGATIVO">AJUSTE NEGATIVO</option>
								
							</select>
						</div>
					</td>
				</tr>

				<tr>

					<td>concepto </td>
					<td>
						<div v-if="!esCobro" class="select is-rounded">
							<select v-model="movimientos.concepto" required>
								<option disabled value="">Concepto</option>
								<option v-if="!esCobro"value="A CUENTA">A CUENTA</option>
								<option v-if="esCobro" value="COBRO">COBRO</option>
								<option v-if="!esCobro" value="DEPOSITO EN GARANTIA">DEPOSITO EN GARANTIA</option>
								<option v-if="esCobro" value="AJUSTE NEGATIVO">AJUSTE MENOS</option>
								<option v-if="esCobro" value="AJUSTE POSITIVO">AJUSTE MENOS</option>								
							</select>
						</div>
						<div v-if="esCobro">
							<input type="text" class="input is-rounded" name="importe2" v-model="movimientos.concepto" required min="1" > 
						</div>
					</td>

				</tr>
				<tr>
					<td>importe </td><td><input type="number" class="input is-rounded" name="importe" v-model="movimientos.importe" required min="1"  ></td>
				</tr>
				<tr v-if="!esCobro" >
					<td>Forma De Pago </td>
					<td>
						<div class="select is-rounded">
							<select v-model="movimientos.formaDePago"  required>
								<option disabled value="">Forma</option>
								<option>DEPOSITO A TARJETA</option>
								<option>TRANSFERENCIA</option>
								<option>EFECTIVO</option>
								<option>CHEQUE</option>
								<option>PAGO CON EL DEPOSITO DE GARANTIA</option>
								<option>TARJETA DE CREDITO</option>
								<option>TARJETA DE DEBITO</option>
								<option>AJUSTE</option>

							</select>

						</div>
					</td>
				</tr>
				<tr>
					<td>fecha del movimiento</td><td><input type="date" class="input is-rounded" name="fecha" v-model="movimientos.fecha" required >
					<br>{{formateaFecha(movimientos.fecha)}}
					</td>
				</tr>
				<tr>
					<td>quien capturo </td><td><input type="text" name="quienCapturo" class="input is-rounded" v-model="movimientos.quienCapturo" disabled></td>
				</tr>
				<tr v-if="!esCobro">
					<td>quien pago </td><td><input type="text" class="input is-rounded" name="quienPago" v-model="movimientos.quienPago" required></td>
				</tr>
				<tr v-if="!esCobro">
					<td>donde </td><td><input type="text" class="input is-rounded" name="donde" v-model="movimientos.donde"></td>
				</tr>
				<tr v-if="!esCobro ">
					<td>ref deposito </td><td><input type="text" name="refDeposito" class="input is-rounded" v-model="movimientos.refDeposito"></td>
				</tr>
				<tr>
					<td>referencia </td><td><input type="text" name="referencia" class="input is-rounded" v-model="movimientos.referencia"></td>
				</tr>
				<tr>
					<td>comentario </td><td><input type="text" name="comentario" class="input is-rounded" v-model="movimientos.comentario"></td>
				</tr>
				<tr>
					<td>recibo ref.</td><td><input type="text" class="input is-rounded" name="recibo" v-model="movimientos.recibo"></td>
				</tr>
				<tr v-if="!esCobro">
					<td>quien recibió </td><td><input type="text" class="input is-rounded" name="recibio" v-model="movimientos.recibio" required></td>
				</tr>
			</table>
		<br>
		<input type="submit" name="agregandoMovimiento" class="button is-primary is-rounded">
		</form>
	</div>
</template>


<script>
	import axios from 'axios';
	import contrat1  from './Contratos-buscar.vue'

	export default{
			name:'agrega-movimiento',
			components: {
				hijo1: contrat1
			},
  			props: ['vector', 'elusuario'],  
			mounted(){
				this.validar();
			},
			data(){
				return {
					movimientos:{
						tipo:'',
						contrato:'',
						inquilinoNombre:'',
						propiedadNombre:'',
						inquilinoNum:'',
						propiedadNum:'',
						concepto:'',
						importe:'',
						formaDePago:'',
						fechaCaptura:'',
						fecha:'',
						quienCapturo:'',
						quienPago:'',
						donde:'',
						refDeposito:'',
						referencia:'',
						comentario:'',
						recibo:'',
						recibio:'',
						familia:'',
						subFamilia:'',
						dueno:'',
						giro:'',
						},
					idCon:'',
					buscar: false,
					buscar1:false 					
				};
			},
			methods:{
				validar(){
			 		// checa si tiene autorizacion
			  		if(!this.vector.includes('MASTERGGUV')){
				  		if(!this.vector.includes('Movimientos Altas')){
			  			document.getElementById('moviAdd').hidden = true;
				  			alert('Seccion no autorizada');
				  			return;
				  		}
				  	} 
				  	this.movimientos.quienCapturo = this.elusuario;	
				},
				aBuscar(){
					this.buscar=true;
					document.getElementById('visible').style.height = "0";	
					document.getElementById('visible').style.visibility = "hidden";	

				},

                                        
				recibeC: function(id, inum, pnum, ino, pno, giro, fam, subf, dueno, mail, renta){
					this.movimientos.contrato=id;
					this.movimientos.inquilinoNombre=ino;
					this.movimientos.propiedadNombre=pno;
					this.movimientos.inquilinoNum=inum;
					this.movimientos.propiedadNum=pnum;
					this.movimientos.familia=fam;
					this.movimientos.subFamilia=subf;
					this.movimientos.dueno=dueno;
					this.movimientos.giro=giro;

					this.buscar=false;

					document.getElementById('visible').style.visibility = "visible";	

				},		

				visibles: function(){
					var tipo = document.getElementById('tipo');
					var valor = tipo.options[tipo.selectedIndex].value;

					if (valor == "COBRO" || valor == "AJUSTE NEGATIVO"){
						this.esCobro = true;

					} else {
						this.esCobro = false;	
				
					}

				},				


				formateaFecha: function (fecha) {
					var d = new Date(fecha); 
					if (Date.parse(d)){
						// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
						d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
						d.setHours(0);
						var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
						d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
						return d

					}else{
						return "sin fecha";
					}
				},
				
				guardarMovimiento(){
					var mov= this.movimientos;
					var router= this.$router;

					// valida algunas entradas
					if(this.movimientos.concepto == "Renta-Mes"){
						alert("El concepto no puede ser Renta-Mes.\nLos cargos de renta los hace \n el sistema automáticamente.\nCambie la redaccion por favor")
					}
					
					// si es deposito inicial no lo suma y guarda la info
					// como referencia.
					if (this.movimientos.concepto == 'DEPOSITO EN GARANTIA' || this.movimientos.tipo == 'DEPOSITO EN GARANTIA'){						
						var ref = "Deposito en garantia $ " + parseFloat(this.movimientos.importe) +' '+ this.movimientos.fecha;
						this.movimientos.referencia = ref + this.movimientos.referencia;		
						this.movimientos.importe = 0;
					}

					// si es movimiento pago lo agrega como negativo
					if (this.movimientos.tipo == 'PAGO' || this.movimientos.tipo == 'AJUSTE NEGATIVO') {
						this.movimientos.importe = - parseFloat(this.movimientos.importe);
					}


					
					axios.post('https://www.directodo.com/Rentus/accesosdb/agregaMovimiento.php?'+'&tipo='+this.movimientos.tipo+'&contrato='+this.movimientos.contrato+'&inquilinoNombre='+this.movimientos.inquilinoNombre+'&propiedadNombre='+this.movimientos.propiedadNombre+'&inquilinoNum='+this.movimientos.inquilinoNum+'&propiedadNum='+this.movimientos.propiedadNum+'&concepto='+this.movimientos.concepto+'&importe='+this.movimientos.importe+'&formaDePago='+this.movimientos.formaDePago+'&fechaCaptura='+this.movimientos.fechaCaptura+'&fecha='+this.movimientos.fecha+'&quienCapturo='+this.movimientos.quienCapturo+'&quienPago='+this.movimientos.quienPago+'&donde='+this.movimientos.donde+'&refDeposito='+this.movimientos.refDeposito+'&referencia='+this.movimientos.referencia+'&comentario='+this.movimientos.comentario+'&recibo='+this.movimientos.recibo+'&recibio='+this.movimientos.recibio+'&familia='+this.movimientos.familia+'&subFamilia='+this.movimientos.subFamilia+'&dueno='+this.movimientos.dueno+'&giro='+this.movimientos.giro)
			  		          .then((respue) => {
			  		          		if (respue.statusText == 'OK'){
			  		          			router.push('/mov')
			  		          		}
			  			 	  })
			  		          .catch((error) =>{
			  		          		console.log(error);
			  		          });
				}
			}
	}

</script>

<style lang="scss">
	#propiAdd{
		padding:20px;
		li{
			width: 20%;
			height: 120px;
			background: #eee;
			overflow: hidden;
		}
	}
</style>


// WEBPACK FOOTER //
// src/Movimiento-agregar.vue